import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

/**
 * Pagination par PAGES pour les listes de PDL (Step5 / Step6).
 * N'affiche qu'une page (10 PDL) à la fois → seules 10 cartes sont montées,
 * la mémoire reste maîtrisée même avec ~200 PDL. Les données saisies sont
 * persistées dans l'état/refs parent, donc rien n'est perdu au changement de page.
 */
export const PdlPagination = ({ page, totalPages, total, pageSize, onPage, testidPrefix }) => {
  if (totalPages <= 1) return null;
  const debut = page * pageSize + 1;
  const fin = Math.min((page + 1) * pageSize, total);
  return (
    <div className="flex items-center justify-center gap-2 flex-wrap py-3" data-testid={`${testidPrefix}-pagination`}>
      <button
        type="button"
        onClick={() => onPage(page - 1)}
        disabled={page === 0}
        className="px-3 py-2 text-sm border border-[#BFC6CC] rounded bg-white hover:bg-[#F5F6F9] disabled:opacity-40 disabled:cursor-not-allowed inline-flex items-center gap-1"
        data-testid={`${testidPrefix}-prev`}
      >
        <ChevronLeft className="w-4 h-4" /> Précédent
      </button>
      <span className="text-sm text-[#191D1E] px-2" data-testid={`${testidPrefix}-page-indicator`}>
        Page <strong>{page + 1}</strong> / {totalPages}
        <span className="text-[#687175]"> (PDL {debut}–{fin} sur {total})</span>
      </span>
      <button
        type="button"
        onClick={() => onPage(page + 1)}
        disabled={page >= totalPages - 1}
        className="px-3 py-2 text-sm border border-[#BFC6CC] rounded bg-white hover:bg-[#F5F6F9] disabled:opacity-40 disabled:cursor-not-allowed inline-flex items-center gap-1"
        data-testid={`${testidPrefix}-next`}
      >
        Suivant <ChevronRight className="w-4 h-4" />
      </button>
      <div className="flex items-center gap-1 ml-2">
        <span className="text-xs text-[#687175]">Aller à la page</span>
        <input
          type="number"
          min={1}
          max={totalPages}
          className="w-16 px-2 py-1 text-sm border border-[#BFC6CC] rounded bg-white"
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              const v = parseInt(e.target.value, 10);
              if (v >= 1 && v <= totalPages) onPage(v - 1);
            }
          }}
          data-testid={`${testidPrefix}-jump`}
          placeholder="#"
        />
      </div>
    </div>
  );
};

export default PdlPagination;
